'use strict';

var index = require('../../../../../_virtual/index2.cjs');
var React = require('react');

const AviaryThemeContext = /*#__PURE__*/ React.createContext({
    setTheme: ()=>null,
    currentTheme: index.cjsExports.fullscriptWebLight.desktop1024
});

exports.AviaryThemeContext = AviaryThemeContext;
//# sourceMappingURL=AviaryThemeContext.cjs.map
